import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';


const RemoveFromAreaControlModal = (props) => {

    const cancel = () => {
        props.onCancel();
    };

    const confirm = () => {
        props.onConfirm(props.items);
    };

    const count = props.items.length;

    return (
        <Modal isOpen={props.visible} centered={true}>
            <ModalHeader>Flächensteuerung beenden</ModalHeader>
            <ModalBody>
                <div className="row">
                    <div className="col-lg-12">
                        Achtung! Sie beenden die Flächensteuerung für {count} Elemente!
                        Sind Sie sicher?
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={confirm}>Ja, beenden</Button>{' '}
                <Button color="secondary" onClick={cancel}>Abbrechen</Button>
            </ModalFooter>
        </Modal>
    )
};

export default RemoveFromAreaControlModal;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/RemoveFromAreaControlModal.js